import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { persistToSessionStorage } from '@nike/ux-tread-web-storage';
import { combineReducers } from 'redux';
import { CART_STATE_KEY } from '@nike/cart-constants';
import ExEnv from 'exenv';
import { metaReducer, cartReducer, totalsReducer, errorsReducer, warningsReducer, inFlightReducer, itemIdsReducer, localeReducer } from './reducers';
export var cartsReducer = combineReducers({
  meta: metaReducer,
  locale: localeReducer,
  cart: cartReducer,
  totals: totalsReducer,
  errors: errorsReducer,
  warnings: warningsReducer,
  inFlight: inFlightReducer,
  itemIds: itemIdsReducer
});

// NOTE - we are using canUseEventListeners because we are tethered to unite still
/**
 * @returns {object} cartsReducer persisted to session storage and attached to the expected key for usage with selectors exported from this module
 */
export function addCartReducer(options) {
  return _defineProperty({}, CART_STATE_KEY, ExEnv.canUseEventListeners && persistToSessionStorage(CART_STATE_KEY, cartsReducer, options));
}